/* eslint-disable react/prop-types */
import { Form } from 'antd';
import Modal from '../../common/Modal';
import styled from 'styled-components';
import CustomButton from '../../common/Button';
import TextArea from 'antd/es/input/TextArea';

interface ReserveSlotModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (note: string) => void;
  reserve: boolean;
}

const ReserveSlotModal: React.FC<ReserveSlotModalProps> = ({
  open,
  onCancel,
  onConfirm,
  reserve,
}) => {
  const [form] = Form.useForm();

  const handleReserve = async () => {
    try {
      const values = await form.validateFields();
      onConfirm(values.note || '');
      form.resetFields();
      onCancel();
    } catch (error) {
      console.log('Validation failed:', error);
    }
  };
  return (
    <Modal
      title={reserve ? 'Reserve Slot' : 'Unreserve Slot'}
      open={open}
      onCancel={onCancel}
      minHeight={'auto'}
    >
      <Form form={form} layout="vertical" onFinish={handleReserve}>
        {reserve ? (
          <StyledFormItem label="Add note" name="note">
            <StyledTextArea placeholder="Type note here ..." />
          </StyledFormItem>
        ) : (
          <StyledText>
            Are you sure you want to permanently unreserve this Slot?
          </StyledText>
        )}
        <ButtonSection>
          <CustomButton onClick={onCancel}>Cancel</CustomButton>
          <CustomButton type="primary" onClick={() => form.submit()}>
            {reserve ? 'Confirm Reserve' : 'Unreserve Slot'}
          </CustomButton>
        </ButtonSection>
      </Form>
    </Modal>
  );
};

const StyledFormItem = styled(Form.Item)`
  width: 100%;
  &.ant-space-item {
    flex: 1;
  }
`;

const StyledText = styled.p`
  width: 100%;
  white-space: nowrap;
`;

const StyledTextArea = styled(TextArea)`
  width: 100%;
  resize: none !important;
  height: 70px !important;
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  margin-top: 32px;
`;

export default ReserveSlotModal;
